// extracted by mini-css-extract-plugin
export default {"wrap":"PF-z","fullWidth":"QF-z","hideOnDesktop":"RF-z","content":"SF-z","hasOpenedNav":"TF-z","crumbsList":"UF-z","dropdownsWrap":"VF-z"};